import createDomPurify from 'dompurify';
import {linkify} from 'remarkable-v2/linkify';
import {Remarkable} from 'remarkable-v2';

const markdownRenderer = new Remarkable('full', {
  html: true,
  linkTarget: '_blank',
}).use(linkify);

const DOMPurify = createDomPurify();

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
});

const DOMPurifyRemoveTargetWhenEmbedded = createDomPurify();

DOMPurifyRemoveTargetWhenEmbedded.addHook(
  'afterSanitizeAttributes',
  function (node) {
    // if the href is a Dashboard link, remove target and rel so it can be handled by
    // widgetLinkAction, and Dashboard can do client side navigation.
    if (
      'target' in node &&
      node.tagName === 'A' &&
      node
        .getAttribute('href')
        ?.startsWith(document.location.ancestorOrigins[0])
    ) {
      node.removeAttribute('target');
    } else {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener');
    }
  },
);

export function renderMarkdownInline(
  text: string,
  options?: {removeTargetInLinks?: boolean},
) {
  const {removeTargetInLinks = false} = options || {};

  // Apply link target handling if needed
  if (removeTargetInLinks) {
    return DOMPurifyRemoveTargetWhenEmbedded.sanitize(
      markdownRenderer.renderInline(text),
    );
  }

  return DOMPurify.sanitize(markdownRenderer.renderInline(text));
}
